import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {
  DemandDetails,
  DemandList,
  DwoDiagnoseCauseReasonTemplate,
} from 'projects/Administration/src/app/business-entities/dwo-diagnose-model';
import { DwoAppointemntSubCheckListViewModel } from 'projects/Administration/src/app/business-entities/dwo-sub-check-list-detail-view-model';
import { DwoDiagnoseBusinessService } from 'projects/Administration/src/app/business-services/dwo-diagnose.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as fromenums from './../../../../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-dwo-diagnose-details',
  templateUrl: './dwo-diagnose-details.component.html',
  styleUrls: ['./dwo-diagnose-details.component.css'],
})
export class DwoDiagnoseDetailsComponent implements OnInit {
  @Input() serviceFormName: string;
  @Input() serviceDiagnoseFormName: string;
  @Input() isSSM: boolean;
  @Input() demand: any;
  demandList: DemandList[];
  diagnose: string;
  reson: string;
  cause: string;
  causeCode: string;
  id: number;
  appointmentGuid: string;

  diagnoseList: DwoAppointemntSubCheckListViewModel[];
  diagnosecheckList: DwoAppointemntSubCheckListViewModel[];
  demandDetails: DemandDetails = {
    appointmentDemandId: 0,
    appointmentId: 0,
    batteryTesterCodes: '',
    causeCodeId: 0,
    causeCodeText: '',
    causeId: 0,
    causeText: '',
    comment:'',
    customerInfo: '',
    diagnoseId: 0,
    diagnoseText: '',
    id: null,
    language: '',
    mechanicId: 0,
    partId: 0,
    reasonId: 0,
    reasonText: '',
    userId: 0,
    createdBy:'',
    createdDate:'',
    createdUser:''
  };
  demandDetailsList: DemandDetails[];
  DiagnoseList: DwoDiagnoseCauseReasonTemplate[];
  CauseList: DwoDiagnoseCauseReasonTemplate[];
  ReasonList: DwoDiagnoseCauseReasonTemplate[];
  CauseCodeList: DwoDiagnoseCauseReasonTemplate[];
  currentlagSub: Subscription;
  editDwoDiagnoseForm: FormGroup;
  formName: string;
  features: Features[] = [];
  isSST: boolean = false;
  isBrandNissan: boolean = false;
  diagnoseId:null;
  userDetails:null;
  constructor(
    private service: DwoDiagnoseBusinessService,
    private editAppointmentService: EditAppointmentService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private clipboardApi: ClipboardService,
    private formBuilder: FormBuilder,
    private userService: UserDataService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private secureStorage: SecureStorage
  ) { }

  ngOnInit(): void {
    this.getUserObj();
    this.formName = this.serviceDiagnoseFormName;
    //Check for historical WO tab -> If true then appointmentGuid will be of selected WO.
    this.editDwoDiagnoseForm = this.formBuilder.group({
      [this.formName]: this.formBuilder.group({
        diagnoseName: [''],
        diagnoseText: [''],
        causeName: [''],
        causeText: [''],
        causeCodeName: [''],
        causeCodeText: [''],
        comment: [''],
        reasonName: [''],
        reasonText: [''],
        customerInfo: [''],
        batteryTesterCodes: [''],
        editCheckListForm: new FormArray([]),
      }),
    });
    this.cpf.editCheckListForm = this.formBuilder.group({
      dynamicFields: this.formBuilder.array([]),
    });
    if (
      this.editAppointmentService.isFromHistoricalWOTab ||
      this.editAppointmentService.isFromVehicleHistoricalTab
    ) {
      this.id = this.editAppointmentService.appointmentIdOfSelectedWO;
      this.appointmentGuid =
        this.editAppointmentService.appointmentGuidOfSelectedWO;
    } else {
      this.id = this.editAppointmentService.appointmentDetails.id;
      this.appointmentGuid =
        this.editAppointmentService.appointmentDetails.appointmentGuid;
    }
    this.GetDemandDetails(this.demand.id);
    if (!(this.service.editFormName === this.serviceFormName)) {
      this.editDwoDiagnoseForm.controls[
        'editDwoDiagnoseFormtoggle-' + this.serviceFormName
      ].disable();
      this.cpf.editCheckListForm.get('dynamicFields').disable();
    }
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features?.length > 0)
    {
      this.isSST = this.features.find(x => x.featureCode === fromenums.FeatureCode.SST)?.isActive;
    }
    if(this.editAppointmentService.appointmentDetails.brandName.toLowerCase() == 'nissan')
    {
     this.isBrandNissan = true; 
    }
    this.form();
  }
  addDynamicField(id: number, type: string, value: any) {
    const dynamicFieldsArray = this.cpf.editCheckListForm.get(
      'dynamicFields'
    ) as FormArray;
    dynamicFieldsArray.push(
      this.formBuilder.group({ id: [id], [type]: [value] })
    );
  }

  get cpf() {
    return this.editDwoDiagnoseForm.controls;
  }

  getFormControlValue(controlName: string): string {
    return this.editDwoDiagnoseForm.controls[
      'editDwoDiagnoseFormtoggle-' + this.serviceFormName
    ]?.get(controlName).value;
  }

  form(){
    this.editDwoDiagnoseForm.enable();
    this.cpf.editCheckListForm.enable();
  }

  diagnoseItems: any[] = [];

  // Process your data to create items array
  processDiagnoseData(demandList:any) {
    this.diagnoseItems = demandList.map(element => ({
      createdBy: element.createdBy,
      createdDate: element.createdDate,
      createdUser:element.createdUser,
      diagnoseText: element.diagnoseText,
      causeText: element.causeText,
      reasonText:element.reasonText,
      comment:element.comment,
      originalElement: element
    }));
  }

  getCopyText(textType:any): string {
    if(textType == 'diagnoseText')
    {
      return this.diagnoseItems.map(item =>
        `${item.createdBy}-${item.createdDate} ${item.diagnoseText}`
      ).join('\n');
    }
    else if(textType == 'comment'){
      return this.diagnoseItems.map(item =>
        `${item.createdBy}-${item.createdDate} ${item.comment}`
      ).join('\n');
    }
    else if(textType == 'causeText'){
      return this.diagnoseItems.map(item =>
        `${item.createdBy}-${item.createdDate} ${item.causeText}`
      ).join('\n');
    }
    else if(textType == 'reasonText'){
      return this.diagnoseItems.map(item =>
        `${item.createdBy}-${item.createdDate} ${item.reasonText}`
      ).join('\n');
    }
  }

  editItem(index: any) {
    this.editDwoDiagnoseForm.controls[
          'editDwoDiagnoseFormtoggle-' + this.serviceFormName
        ].patchValue({
          diagnoseName: index.originalElement.diagnoseId,
          diagnoseText: index.originalElement.diagnoseText,
          causeName: index.originalElement.causeId,
          causeText: index.originalElement.causeText,
          causeCodeName: index.originalElement.causeCodeId,
          causeCodeText: index.originalElement.causeCodeText,
          comment: index.originalElement.comment,
          reasonName: index.originalElement.reasonId,
          reasonText: index.originalElement.reasonText,
          customerInfo: index.originalElement.customerInfo,
          batteryTesterCodes: index.originalElement.batteryTesterCodes,
    });
    this.diagnoseId = index.originalElement.id
  }

  GetDemandDetails(demandId: number) {
    this.spinner.show();
    this.service
      .getDemandDetails(this.appointmentGuid, demandId)
      .then((res) => {
        this.demandDetailsList = res.responseObject;
        this.demandDetails.appointmentId = this.editAppointmentService.appointmentDetails.appointmentId;
        this.demandDetails.appointmentDemandId = demandId;        
        if (this.demandDetailsList?.length !== undefined) {
          this.processDiagnoseData(this.demandDetailsList);
          this.demandDetails = this.demandDetailsList[0];
          this.demandDetails.id = this.demandDetailsList[0].id;
          this.demandDetails.mechanicId = this.demandDetailsList[0].mechanicId;
        }
        this.editDwoDiagnoseForm.controls[
          'editDwoDiagnoseFormtoggle-' + this.serviceFormName
        ].patchValue({
          customerInfo: this.demandDetails.customerInfo,
          batteryTesterCodes: this.demandDetails.batteryTesterCodes,
        });
        this.spinner.hide();
      });
    this.GetCheckList(demandId);
  }

  copyTextDetail(copyText: string) {
    this.clipboardApi.copyFromContent(copyText);
  }

  changeDiagonseText(event) {
    let selectedDiagnose = this.service.DiagnoseList.find((x) => x.id == event);
    this.demandDetails.diagnoseId = +event;
    this.editDwoDiagnoseForm.controls[
      'editDwoDiagnoseFormtoggle-' + this.serviceFormName
    ]
      .get('diagnoseText')
      .setValue(selectedDiagnose.template);
  }

  changeCauseText(event) {
    let selectedCause = this.service.CauseList.find((x) => x.id == event);
    this.demandDetails.causeId = +selectedCause.id;
    this.editDwoDiagnoseForm.controls[
      'editDwoDiagnoseFormtoggle-' + this.serviceFormName
    ]
      .get('causeText')
      .setValue(selectedCause.template);
  }

  changeCauseCodeText(event) {
    let selectedCauseCode = this.service.CauseCodeList.find(
      (x) => x.id == event
    );
    this.demandDetails.causeCodeId = +selectedCauseCode.id;
    this.editDwoDiagnoseForm.controls[
      'editDwoDiagnoseFormtoggle-' + this.serviceFormName
    ]
      .get('causeCodeText')
      .setValue(selectedCauseCode.template);
  }

  changeReasonText(event) {
    let selectedReason = this.service.ReasonList.find((x) => x.id == event);
    this.demandDetails.reasonId = +selectedReason.id;
    this.editDwoDiagnoseForm.controls[
      'editDwoDiagnoseFormtoggle-' + this.serviceFormName
    ]
      .get('reasonText')
      .setValue(selectedReason.template);
  }
  get c() {
    return this.cpf.editCheckListForm as FormArray;
  }

  async GetCheckList(demandId) {
    let viewModel = {
      //appointmentId: this.id,
      appointmentGuid: this.appointmentGuid,
      clType: this.isSSM ? fromenums.ClType.SSM : fromenums.ClType.Diagnose,
      langCode: this.cookieservice.get('userSelectedLanguage'),
      appointmentDemandId: demandId,
    };
    this.demandDetails.language = this.cookieservice.get(
      'userSelectedLanguage'
    );
    this.demandDetails.appointmentDemandId = demandId;
    this.spinner.show();
    this.service.getCheckList(viewModel).then((res) => {
      this.diagnoseList = res.responseObject;
      if (this.diagnoseList?.length) {
        this.diagnosecheckList = this.diagnoseList;
      }
      this.diagnosecheckList?.forEach((element) => {
        element.showTitle = element.checkListItems.some((item) => {
          return item.isQuestionActive === true;
        });
      });
      this.diagnosecheckList?.forEach((data) => {
        data.checkListItems.forEach((element) => {
          this.addDynamicField(element.id, 'textAnswer', element.textBoxValue);
          element.checkListItemType?.forEach((item) => {
            this.addDynamicField(item.id, 'checkAnswer', item.checkBoxValue);
          });
          element.checkListRadioItemType?.forEach((item) => {
            this.addDynamicField(item.id, 'radioAnswer', item.radioButtonValue);
          });
        });
      });
    });
    this.spinner.hide();
  }

  updateDynamicFieldValue(id: number, newValue: any, type: string) {
    const dynamicFieldsArray = this.cpf.editCheckListForm.get(
      'dynamicFields'
    ) as FormArray;
    const index = dynamicFieldsArray.controls.findIndex(
      (control) => control.get('id').value === id
    );
    const fieldControl = dynamicFieldsArray.at(index).get(type) as FormControl;
    fieldControl.patchValue(newValue);
  }

  onSave() {
    this.spinner.show();
    let successMessage = this.translate.instant('lblDWOData');
    let errorMessage = this.translate.instant('lblErrorMessage');
    const data =
      this.editDwoDiagnoseForm.controls[
        'editDwoDiagnoseFormtoggle-' + this.serviceFormName
      ].value;
    let model = {
      id: this.diagnoseId != null ? this.diagnoseId : 0,
      appointmentId: this.editAppointmentService.appointmentDetails.appointmentId,
      appointmentDemandId: this.demandDetails.appointmentDemandId,
      shortDescription: this.demand.shortDescription,
      mechanicId: this.demandDetails.mechanicId,
      language: this.demandDetails.language,
      diagnoseId: data.diagnoseName,
      diagnoseText: data.diagnoseText,
      causeId: data.causeName,
      causeText: data.causeText,
      reasonId: data.reasonName,
      reasonText: data.reasonText,
      causeCodeId: data.causeCodeName,
      causeCodeText: data.causeCodeText,
      comment: data.comment,
      userId: this.userService.currentUserValue.id,
      customerInfo: data.customerInfo,
      partId: 1,
      batteryTesterCodes: data.batteryTesterCodes,
    };
    let checkListdata = {
      AppointmentId:
        this.editAppointmentService.appointmentDetails.appointmentId,
      appointmentDemandId: this.demandDetails.appointmentDemandId,
      LangCode: this.demandDetails.language,
      ClType: 2,
      DwoCheckListAppointmentAnswers:
        this.cpf.editCheckListForm.value.dynamicFields,
    };
    this.service.SaveJobDiagnoseCauseReason(model).then(
      (res) => {
        if (res.responseObject) {
          if (this.diagnosecheckList != null && !(this.isSST && this.isBrandNissan)) {
            this.service.SaveCheckList(checkListdata).then((_res) => {
              this.spinner.hide();
            });
          }
          this.spinner.hide();
          this.toaster.success(successMessage);
          this.GetDemandDetails(this.demand.id);
          this.editDwoDiagnoseForm.controls[
            'editDwoDiagnoseFormtoggle-' + this.serviceFormName
          ].reset({
              diagnoseName: '',
              diagnoseText: '',
              diagnoseDisableText: '',
              causeName: '',
              causeText: '',
              causeDisableText: '',
              causeCodeName: '',
              causeCodeText: '',
              causeCodeDisableText: '',
              comment: '',
              reasonName: '',
              reasonText: '',
              reasonDisableText: '',
              customerInfo: '',
              batteryTesterCodes: '',
              editCheckListForm: [] 
          })
          this.diagnoseId == null;
        } else {
          this.spinner.hide();
          this.toaster.error(errorMessage);
        }
      },
      (_error) => {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      }
    );
  }

  getUserObj()
  {
    this.userDetails = this.secureStorage.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
  }

  Cancelform() {
    this.service.editFormName = '';
    this.diagnoseId = null;
    this.editDwoDiagnoseForm.controls[
      'editDwoDiagnoseFormtoggle-' + this.serviceFormName
    ].reset({
      diagnoseId: '',
      diagnoseName: '',
      diagnoseText: '',
      diagnoseDisableText: '',
      causeId: '',
      causeName: '',
      causeText: '',
      causeDisableText: '',
      causeCodeId: '',
      causeCodeName: '',
      causeCodeText: '',
      causeCodeDisableText: '',
      comment: '',
      reasonName: '',
      reasonText: '',
      reasonDisableText: '',
      customerInfo: '',
      batteryTesterCodes: '',
      editCheckListForm: new FormArray([]),
    });
  }
  
  isFormEmpty(): boolean {
    const formGroup = this.editDwoDiagnoseForm.controls[this.formName] as FormGroup;
    if (!formGroup) {
      return true;
    }

    const controls = formGroup.controls;
    
    const diagnoseText = controls['diagnoseText']?.value;
    const causeText = controls['causeText']?.value;
    const reasonText = controls['reasonText']?.value;
    const comment = controls['comment']?.value;
    const customerInfo = controls['customerInfo']?.value;
    const batteryTesterCodes = controls['batteryTesterCodes']?.value;

    return (!diagnoseText || diagnoseText.trim() === '') &&
           (!causeText || causeText.trim() === '') &&
           (!reasonText || reasonText.trim() === '') &&
           (!comment || comment.trim() === '') &&
           (!customerInfo || customerInfo.trim() === '') &&
           (!batteryTesterCodes || batteryTesterCodes.trim() === '');
  }
  
  getButtonLabel(): string {
    return this.diagnoseId != null ? 'lblUpdate' : 'lblSave';
  }
}
